import { render, staticRenderFns } from "./ConfiguracaoBoletos.vue?vue&type=template&id=15da42ac&"
import script from "./ConfiguracaoBoletos.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoBoletos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports